export const EVENTS = {
  // GENERIC EVENTS
  LANDING_PAGE_VIEWED: 'PHOENIX_LANDING_PAGE_VIEWED',
  LOGIN_PAGE_VIEWED: 'PHOENIX_LOGIN_PAGE_VIEWED',
  LOGIN_EMAIL_SUBMITTED: 'PHOENIX_LOGIN_EMAIL_SUBMITTED',
  LOGIN_METHOD_CHOSEN: 'PHOENIX_LOGIN_METHOD_CHOSEN',
  LOGIN_OTP_SUBMITTED: 'PHOENIX_LOGIN_OTP_SUBMITTED',
  LOGIN_PASSWORD_SUBMITTED: 'PHOENIX_LOGIN_PASSWORD_SUBMITTED',
  LOGIN_PASSWORD_SETUP_COMPLETED: 'PHOENIX_LOGIN_PASSWORD_SETUP_COMPLETED',
  LOGIN_OTP_RESENT: 'PHOENIX_LOGIN_OTP_RESENT',
  ACCESSIBILITY_SETTINGS_UPDATED: 'PHOENIX_ACCESSIBILITY_SETTINGS_UPDATED',
  ACCOUNT_REGISTER_COMPLETED: 'PHOENIX_ACCOUNT_REGISTER_COMPLETED',
  WALLET_VIEWED: 'PHOENIX_WALLET_VIEWED',
  WALLET_SAVED: 'PHOENIX_WALLET_SAVED',
  ACCOUNT_SCHOOLS_UPDATE: 'PHOENIX_ACCOUNT_SCHOOLS_UPDATE',
  ACCOUNT_DELETED: 'PHOENIX_ACCOUNT_DELETED',
  FEATURE_FLAG_IMPRESSION: 'PHOENIX_FEATURE_FLAG_IMPRESSION',
  // Mixpanel's own exposure event, read by its Experiments report; fired by useExperiment only.
  EXPERIMENT_STARTED: '$experiment_started',

  // INVITE EVENTS
  INVITE_PAGE_VIEWED: 'PHOENIX_INVITE_PAGE_VIEWED',
  INVITE_DECLINED: 'PHOENIX_INVITE_DECLINED',
  INVITE_ACCEPTED: 'PHOENIX_INVITE_ACCEPTED',
  INVITE_EXPIRED: 'PHOENIX_INVITE_EXPIRED',
  INVITE_OTP_SUBMITTED: 'PHOENIX_INVITE_OTP_SUBMITTED',
  INVITE_OTP_RESENT: 'PHOENIX_INVITE_OTP_RESENT',

  // VERIFICATION
  PHONE_VERIFICATION_CODE_REQUESTED:
    'PHOENIX_PHONE_VERIFICATION_CODE_REQUESTED',
  PHONE_VERIFICATION_SUBMIT: 'PHOENIX_PHONE_VERIFICATION_SUBMIT',
  PHONE_VERIFICATION_COMPLETE: 'PHOENIX_PHONE_VERIFICATION_COMPLETE',

  // LEARN
  LEARN_LANDING_PAGE_VIEWED: 'PHOENIX_LEARN_LANDING_PAGE_VIEWED',
  LEARN_TOPIC_VIEWED: 'PHOENIX_LEARN_TOPIC_VIEWED',
  LEARN_TOPIC_SECTION_BACK_CLICKED: 'PHOENIX_LEARN_TOPIC_SECTION_BACK_CLICKED',
  LEARN_TOPIC_EXIT: 'PHOENIX_LEARN_TOPIC_EXIT',
  LEARN_TOPIC_CARD_CLICKED: 'PHOENIX_LEARN_TOPIC_CARD_CLICKED',
  LEARN_TOPIC_SECTION_VIEWED: 'PHOENIX_LEARN_TOPIC_SECTION_VIEWED',
  LEARN_LOGIN_CLICKED: 'PHOENIX_LEARN_LOGIN_CLICKED',
  LEARN_COMPLETE_PAGE_LOGIN_CLICKED:
    'PHOENIX_LEARN_COMPLETE_PAGE_LOGIN_CLICKED',
  LEARN_COMPLETE_PAGE_SURVEY_BUTTON_CLICKED:
    'PHOENIX_LEARN_COMPLETE_PAGE_SURVEY_BUTTON_CLICKED',
  LEARN_COMPLETE_PAGE_UNLOCK_REWARD_BUTTON_CLICKED:
    'PHOENIX_LEARN_COMPLETE_PAGE_UNLOCK_REWARD_BUTTON_CLICKED',
  LEARN_TOPIC_SECTION_COMPLETED: 'PHOENIX_LEARN_TOPIC_SECTION_COMPLETED',
  LEARN_TOPIC_QUIZ_ANSWERED: 'PHOENIX_LEARN_TOPIC_QUIZ_ANSWERED',
  LEARN_TOPIC_COMPLETED: 'PHOENIX_LEARN_TOPIC_COMPLETED',
  LEARN_DASHBOARD_VIEWED: 'PHOENIX_LEARN_DASHBOARD_VIEWED',
  LEARN_DELETE_ACCOUNT: 'PHOENIX_LEARN_DELETE_ACCOUNT',
  LEARN_TOPIC_NO_MONEY_CLICKED: 'PHOENIX_LEARN_TOPIC_NO_MONEY_CLICKED',
  LEARN_TOPIC_BACK_TO_LEARNING_CLICKED:
    'PHOENIX_LEARN_TOPIC_BACK_TO_LEARNING_CLICKED',
  LEARN_TOPIC_KEEP_EXPLORING_CLICKED:
    'PHOENIX_LEARN_TOPIC_KEEP_EXPLORING_CLICKED',
  LEARN_TOPIC_EXPLORE_LOAD_MORE: 'PHOENIX_LEARN_TOPIC_EXPLORE_LOAD_MORE',
  LEARN_LOGOUT_CLICKED: 'PHOENIX_LEARN_LOGOUT_CLICKED',
  LEARN_FAQ_OPENED: 'PHOENIX_LEARN_FAQ_OPENED',
  LEARN_REWARDS_LEARN_MORE_CLICKED: 'PHOENIX_LEARN_REWARDS_LEARN_MORE_CLICKED',
  LEARN_CHANNEL_CARD_CLICKED: 'PHOENIX_LEARN_CHANNEL_CARD_CLICKED',
  LEARN_CHANNEL_EXPLORE_LOAD_MORE: 'PHOENIX_LEARN_CHANNEL_EXPLORE_LOAD_MORE',
  LEARN_USER_WAITLISTED: 'PHOENIX_LEARN_USER_WAITLISTED',
  LEARN_VERIFIED_KEEP_EXPLORING_CLICKED:
    'PHOENIX_LEARN_VERIFIED_KEEP_EXPLORING_CLICKED',
  LEARN_TOPIC_VIDEO_PLAYED: 'PHOENIX_LEARN_TOPIC_VIDEO_PLAYED',
  LEARN_TOPIC_VIDEO_ENDED: 'PHOENIX_LEARN_TOPIC_VIDEO_ENDED',
  LEARN_TOPIC_VIDEO_PROGRESSED: 'PHOENIX_LEARN_TOPIC_VIDEO_PROGRESSED',
  LEARN_TOPIC_VIDEO_ERROR: 'PHOENIX_LEARN_TOPIC_VIDEO_ERROR',
  LEARN_TOPIC_VIDEO_PAUSED: 'PHOENIX_LEARN_TOPIC_VIDEO_PAUSED',
  LEARN_TOPIC_VIDEO_VOLUME_CHANGED: 'PHOENIX_LEARN_TOPIC_VIDEO_VOLUME_CHANGED',
  UNIFIED_LEARN_COLLECTIONS_PAGE_VIEWED: 'unified.learn.collections.page_viewed',
  UNIFIED_LEARN_COLLECTIONS_CARD_CLICKED: 'unified.learn.collections.card_clicked',
  UNIFIED_LEARN_COLLECTIONS_LOAD_MORE: 'unified.learn.collections.load_more',
  UNIFIED_LEARN_COLLECTIONS_SEARCHED: 'unified.learn.collections.searched',
  UNIFIED_LEARN_EXPLORE_PAGE_VIEWED: 'unified.learn.explore.page_viewed',
  UNIFIED_LEARN_EXPLORE_CARD_CLICKED: 'unified.learn.explore.card_clicked',
  UNIFIED_LEARN_EXPLORE_LOAD_MORE: 'unified.learn.explore.load_more',
  UNIFIED_LEARN_EXPLORE_SEARCHED: 'unified.learn.explore.searched',
  UNIFIED_LEARN_IA_FILTER_CHANGED: 'unified.learn.filter_changed',
  UNIFIED_LEARN_IA_ARTICLES_SEARCHED: 'unified.learn.articles.searched',
  UNIFIED_LEARN_IA_ARTICLES_LOAD_MORE: 'unified.learn.articles.load_more',
  UNIFIED_LEARN_IA_ARTICLES_CARD_CLICKED: 'unified.learn.articles.card_clicked',
  UNIFIED_LEARN_IA_VIDEOS_CARD_CLICKED: 'unified.learn.videos.card_clicked',
  UNIFIED_SELF_DISCOVERY_CARD_CLICKED: 'unified.self_discovery.card_clicked',
  UNIFIED_SELF_DISCOVERY_RESULTS_VIEWED: 'unified.self_discovery.results_viewed',
  UNIFIED_CDP_PAGE_VIEWED: 'unified.cdp.page_viewed',
  UNIFIED_CDP_DOWNLOAD_PDF_CLICKED: 'unified.cdp.download_pdf_clicked',
  UNIFIED_CDP_SHARE_LINK_COPIED: 'unified.cdp_share.link_copied',
  UNIFIED_CDP_SHARE_LINK_SHARED: 'unified.cdp_share.link_shared',
  UNIFIED_CDP_SHARE_ENTRY_CLICKED: 'unified.cdp_share.entry_clicked',
  UNIFIED_CDP_SHARE_CREATED: 'unified.cdp_share.created',
  UNIFIED_CDP_SHARE_REVOKED: 'unified.cdp_share.revoked',
  // Holding page
  HOLDING_PAGE_VIEWED: 'PHOENIX_HOLDING_PAGE_VIEWED',
  ABOUT_PAGE_VIEWED: 'PHOENIX_ABOUT_PAGE_VIEWED',

  // COACH
  // Payloads are content-free by rule: ids, kinds and counts only. Nothing a student typed —
  // no message text, no goal wording — ever reaches an analytics provider.
  COACH_SESSION_STARTED: 'coach.session_started',
  COACH_MESSAGE_SENT: 'coach.message_sent',
  COACH_QUESTION_ANSWERED: 'coach.question_answered',
  COACH_GOAL_SET: 'coach.goal_set',
  COACH_GOAL_ACHIEVED: 'coach.goal_achieved',
  COACH_STARTER_CLICKED: 'coach.starter_clicked',
  COACH_RECOMMENDATION_CLICKED: 'coach.recommendation_clicked',
  COACH_SESSION_ENDED: 'coach.session_ended',
  COACH_VOICE_STARTED: 'coach.voice_started',
  COACH_VOICE_STOPPED: 'coach.voice_stopped',

  // PATHWAYS
  RETRY_PATHWAY_BUTTON_CLICKED: 'PHOENIX_RETRY_PATHWAY_BUTTON_CLICKED',
  PATHWAY_THEMES_ACTIVITY_VIEWED: 'PHOENIX_PATHWAY_THEMES_ACTIVITY_VIEWED',
  PATHWAY_EXPLORATION_ACTIVITY_VIEWED:
    'PHOENIX_PATHWAY_EXPLORATION_ACTIVITY_VIEWED',

  // V3 ACTIVITY INSTITUTION
  INSTITUTION_ACTIVITY_VIEWED: 'PHOENIX_INSTITUTION_ACTIVITY_VIEWED',
  INSTITUTION_ACTIVITY_EXITED: 'PHOENIX_INSTITUTION_ACTIVITY_EXITED',
  INSTITUTION_FAVOURITED: 'PHOENIX_INSTITUTION_FAVOURITED',
  INSTITUTION_SENTIMENT: 'PHOENIX_INSTITUTION_SENTIMENT',

  // V3 ACTIVITY JOB
  JOB_ACTIVITY_VIEWED: 'PHOENIX_JOB_ACTIVITY_VIEWED',
  JOB_ACTIVITY_EXITED: 'PHOENIX_JOB_ACTIVITY_EXITED',
  JOB_FAVOURITED: 'PHOENIX_JOB_FAVOURITED',
  JOB_SENTIMENT: 'PHOENIX_JOB_SENTIMENT',

  // SAVED ENTITIES
  ENTITY_SAVED: 'PHOENIX_ENTITY_SAVED',
  ENTITY_UNSAVED: 'PHOENIX_ENTITY_UNSAVED',

  // GTKY
  GTKY_QUESTION_ANSWERED: 'PHOENIX_GTKY_QUESTION_ANSWERED',
  GTKY_QUESTION_VIEWED: 'PHOENIX_GTKY_QUESTION_VIEWED',
  GTKY_SECTION_STARTED: 'PHOENIX_GTKY_SECTION_STARTED',
  GTKY_SECTION_COMPLETED: 'PHOENIX_GTKY_SECTION_COMPLETED',

  // SCHOOLS
  SCHOOLS_LANDING_VIEWED: 'PHOENIX_SCHOOLS_LANDING_VIEWED',
  SCHOOLS_LANDING_CTA_CLICKED: 'PHOENIX_SCHOOLS_LANDING_CTA_CLICKED',
  SCHOOLS_LEADERS_LANDING_VIEWED: 'PHOENIX_SCHOOLS_LEADERS_LANDING_VIEWED',
  SCHOOLS_LEADERS_LANDING_CTA_CLICKED: 'PHOENIX_SCHOOLS_LEADERS_LANDING_CTA_CLICKED',
  SCHOOLS_ADVISORS_LANDING_VIEWED: 'PHOENIX_SCHOOLS_ADVISORS_LANDING_VIEWED',
  SCHOOLS_ADVISORS_LANDING_CTA_CLICKED: 'PHOENIX_SCHOOLS_ADVISORS_LANDING_CTA_CLICKED',
  SCHOOLS_REWARDS_LANDING_VIEWED: 'PHOENIX_SCHOOLS_REWARDS_LANDING_VIEWED',
  SCHOOLS_REWARDS_LANDING_CTA_CLICKED: 'PHOENIX_SCHOOLS_REWARDS_LANDING_CTA_CLICKED',
  SCHOOLS_FAQ_OPENED: 'PHOENIX_SCHOOLS_FAQ_OPENED',
  SCHOOLS_LESSON_EDIT_CLICKED: 'PHOENIX_SCHOOLS_LESSON_EDIT_CLICKED',
  SCHOOLS_LESSON_OVERVIEW_VIEWED: 'PHOENIX_SCHOOLS_LESSON_OVERVIEW_VIEWED',
  SCHOOLS_LESSON_START_AND_SHARE_CLICKED: 'PHOENIX_SCHOOLS_LESSON_START_AND_SHARE_CLICKED',
  SCHOOLS_LESSON_DRAFT_DISCARD_CLICKED: 'PHOENIX_SCHOOLS_LESSON_DRAFT_DISCARD_CLICKED',
  SCHOOLS_LESSON_INSIGHTS_REFRESH_CLICKED: 'PHOENIX_SCHOOLS_LESSON_INSIGHTS_REFRESH_CLICKED',
  SCHOOLS_LESSON_INSIGHTS_VIEWED: 'PHOENIX_SCHOOLS_LESSON_INSIGHTS_VIEWED',
  SCHOOLS_LESSON_FEEDBACK_OPT_IN_TOGGLED: 'PHOENIX_SCHOOLS_LESSON_FEEDBACK_OPT_IN_TOGGLED',
  SCHOOLS_LESSON_FEEDBACK_VIEWED: 'PHOENIX_SCHOOLS_LESSON_FEEDBACK_VIEWED',
  SCHOOLS_LESSON_FEEDBACK_PREVIEW_VIEWED: 'PHOENIX_SCHOOLS_LESSON_FEEDBACK_PREVIEW_VIEWED',
  SCHOOLS_INVITE_STUDENTS_CLICKED: 'PHOENIX_SCHOOLS_INVITE_STUDENTS_CLICKED',
  SCHOOLS_VERIFICATION_REQUEST_CLICKED: 'PHOENIX_SCHOOLS_VERIFICATION_REQUEST_CLICKED',
  SCHOOLS_STUDENT_INVITE_RESENT: 'PHOENIX_SCHOOLS_STUDENT_INVITE_RESENT',
  SCHOOLS_STUDENT_INVITE_BULK_RESENT: 'PHOENIX_SCHOOLS_STUDENT_INVITE_BULK_RESENT',
  SCHOOLS_STUDENT_REMOVED: 'PHOENIX_SCHOOLS_STUDENT_REMOVED',
  SCHOOLS_STUDENT_BULK_REMOVED: 'PHOENIX_SCHOOLS_STUDENT_BULK_REMOVED',
  SCHOOLS_STUDENT_GROUPS_UPDATED: 'PHOENIX_SCHOOLS_STUDENT_GROUPS_UPDATED',
  SCHOOLS_STUDENT_GROUP_CREATED: 'PHOENIX_SCHOOLS_STUDENT_GROUP_CREATED',
  SCHOOLS_STUDENT_GROUP_UPDATED: 'PHOENIX_SCHOOLS_STUDENT_GROUP_UPDATED',
  SCHOOLS_STUDENT_GROUP_DELETED: 'PHOENIX_SCHOOLS_STUDENT_GROUP_DELETED',
  SCHOOLS_STUDENT_GROUP_MEMBERS_CHANGED: 'PHOENIX_SCHOOLS_STUDENT_GROUP_MEMBERS_CHANGED',
  SCHOOLS_VIEW_ACTIVITY_CLICKED: 'PHOENIX_SCHOOLS_VIEW_ACTIVITY_CLICKED',
  SCHOOLS_LESSONS_HUB_VIEWED: 'PHOENIX_SCHOOLS_LESSONS_HUB_VIEWED',
  SCHOOLS_FEEDBACK_CLICKED: 'PHOENIX_SCHOOLS_FEEDBACK_CLICKED',
  SCHOOLS_FEEDBACK_SUBMITTED: 'PHOENIX_SCHOOLS_FEEDBACK_SUBMITTED',
  SCHOOLS_LESSON_CARD_CLICKED: 'PHOENIX_SCHOOLS_LESSON_CARD_CLICKED',
  SCHOOLS_EXPO_CARD_CLICKED: 'PHOENIX_SCHOOLS_EXPO_CARD_CLICKED',
  SCHOOLS_EXPO_EXPLAINER_OPENED: 'PHOENIX_SCHOOLS_EXPO_EXPLAINER_OPENED',
  SCHOOLS_ACTIVATE_LESSON_CLICKED: 'PHOENIX_SCHOOLS_ACTIVATE_LESSON_CLICKED',
  SCHOOLS_ACTIVATE_LESSON_SUCCEEDED: 'PHOENIX_SCHOOLS_ACTIVATE_LESSON_SUCCEEDED',
  SCHOOLS_CLONED_LESSON_TEMPLATE_SUCCEEDED: 'PHOENIX_SCHOOLS_CLONED_LESSON_TEMPLATE_SUCCEEDED',
  SCHOOLS_LESSON_ARCHIVE_CLICKED: 'PHOENIX_SCHOOLS_LESSON_ARCHIVE_CLICKED',
  SCHOOLS_LESSON_ARCHIVE_SUCCEEDED: 'PHOENIX_SCHOOLS_LESSON_ARCHIVE_SUCCEEDED',
  SCHOOLS_LESSON_DRAFT_DISCARD_SUCCEEDED: 'PHOENIX_SCHOOLS_LESSON_DRAFT_DISCARD_SUCCEEDED',
  SCHOOLS_LESSON_UPDATE_ACCESS_CLICKED: 'PHOENIX_SCHOOLS_LESSON_UPDATE_ACCESS_CLICKED',
  SCHOOLS_LESSON_UPDATE_ACCESS_SUCCEEDED: 'PHOENIX_SCHOOLS_LESSON_UPDATE_ACCESS_SUCCEEDED',
  SCHOOLS_PREVIEW_LESSON_OPENED: 'PHOENIX_SCHOOLS_PREVIEW_LESSON_OPENED',
  SCHOOLS_TERMS_ACCEPTED: 'PHOENIX_SCHOOLS_TERMS_ACCEPTED',

  // LESSON START (student join via QR)
  LESSON_START_PAGE_VIEWED: 'PHOENIX_LESSON_START_PAGE_VIEWED',
  LESSON_START_JOIN_CLICKED: 'PHOENIX_LESSON_START_JOIN_CLICKED',
  LESSON_START_LOGIN_CLICKED: 'PHOENIX_LESSON_START_LOGIN_CLICKED',
  LESSON_START_ACCESS_DENIED: 'PHOENIX_LESSON_START_ACCESS_DENIED',
  SCHOOLS_MY_LESSON_OPENED: 'PHOENIX_SCHOOLS_MY_LESSON_OPENED',
  SCHOOLS_EDIT_LESSON_OPENED: 'PHOENIX_SCHOOLS_EDIT_LESSON_OPENED',
  SCHOOLS_LESSON_CURRICULUM_UNMET_SHOWN: 'PHOENIX_SCHOOLS_LESSON_CURRICULUM_UNMET_SHOWN',
  SCHOOLS_EDIT_LESSON_SAVE_CLICKED: 'PHOENIX_SCHOOLS_EDIT_LESSON_SAVE_CLICKED',
  SCHOOLS_EDIT_LESSON_SAVED: 'PHOENIX_SCHOOLS_EDIT_LESSON_SAVED',
  SCHOOLS_EDIT_LESSON_CANCEL_CLICKED: 'PHOENIX_SCHOOLS_EDIT_LESSON_CANCEL_CLICKED',
  SCHOOLS_ADD_LESSONS_OPENED: 'PHOENIX_SCHOOLS_ADD_LESSONS_OPENED',
  SCHOOLS_LESSONS_CREATE_WITH_AI_CLICKED: 'PHOENIX_SCHOOLS_LESSONS_CREATE_WITH_AI_CLICKED',
  SCHOOLS_LESSONS_BUILD_VIEWED: 'PHOENIX_SCHOOLS_LESSONS_BUILD_VIEWED',
  SCHOOLS_LESSONS_BUILD_GENERATE_CLICKED: 'PHOENIX_SCHOOLS_LESSONS_BUILD_GENERATE_CLICKED',
  SCHOOLS_AUTH_LOGOUT: 'PHOENIX_SCHOOLS_AUTH_LOGOUT',

  PHOENIX_REFERRAL_CODE_COPIED: 'PHOENIX_REFERRAL_CODE_COPIED',
  PHOENIX_REFERRAL_CODE_SHARED: 'PHOENIX_REFERRAL_CODE_SHARED',
  PHOENIX_REFERRAL_INVITE_EMAIL_SENT: 'PHOENIX_REFERRAL_INVITE_EMAIL_SENT',
  PHOENIX_REFERRAL_CLAIM_STARTED: 'PHOENIX_REFERRAL_CLAIM_STARTED',
  PHOENIX_REFERRAL_PAYMENT_CLAIMED: 'PHOENIX_REFERRAL_PAYMENT_CLAIMED',

  // STORIES
  LEARNING_ASSET_STARTED: 'PHOENIX_LEARNING_ASSET_STARTED',
  LEARNING_ASSET_SKILL_AWARDED: 'PHOENIX_LEARNING_ASSET_SKILL_AWARDED',
  LEARNING_ASSET_COMPLETED: 'PHOENIX_LEARNING_ASSET_COMPLETED',

  // STORY ASSETS
  STORY_ASSET_PUBLISHED: 'PHOENIX_STORY_ASSET_PUBLISHED',
  STORY_ASSET_UNPUBLISHED: 'PHOENIX_STORY_ASSET_UNPUBLISHED',

  // UNIFIED APP
  UNIFIED_CAMPAIGN_ONBOARDING_STARTED: 'unified.campaign.onboarding.started',
  UNIFIED_CAMPAIGN_ONBOARDING_STEP_VIEWED: 'unified.campaign.onboarding.step_viewed',
  UNIFIED_CAMPAIGN_ONBOARDING_EXISTING_USER_SIGNED_IN: 'unified.campaign.onboarding.existing_user_signed_in',
  UNIFIED_CAMPAIGN_ONBOARDING_COMPLETED: 'unified.campaign.onboarding.completed',
  UNIFIED_CAMPAIGN_ONBOARDING_ABANDONED: 'unified.campaign.onboarding.abandoned',
  UNIFIED_SIGN_IN_QUESTIONS_STEP_VIEWED: 'unified.sign_in_questions.step_viewed',
  UNIFIED_CAMPAIGN_ENTRY_CLICKED: 'unified.campaign.entry_clicked',
  UNIFIED_CAMPAIGN_ENTRY_CONFIRMED: 'unified.campaign.entry_confirmed',
  UNIFIED_PROFILE_DETAILS_COMPLETED: 'unified.profile.details_completed',

  // EXPLORE
  UNIFIED_EXPLORE_SEARCHED: 'unified.explore.searched',
  UNIFIED_EXPLORE_RESULT_CLICKED: 'unified.explore.result_clicked',
  UNIFIED_EXPLORE_CATEGORY_CLICKED: 'unified.explore.category_clicked',
  // Explore's directory categories (institutions, courses, jobs, industries) and the Explore index's
  // rows, told apart by `page`. The /institutions page sends its own UNIFIED_INSTITUTION_GUIDE_* events.
  UNIFIED_EXPLORE_IA_FILTER_CHANGED: 'unified.explore.filter_changed',
  UNIFIED_EXPLORE_IA_LOAD_MORE: 'unified.explore.load_more',
  UNIFIED_EXPLORE_IA_CARD_CLICKED: 'unified.explore.card_clicked',

  // INSTITUTIONS DIRECTORY
  UNIFIED_INSTITUTION_GUIDE_SEARCHED: 'unified.institution_guide.searched',
  UNIFIED_INSTITUTION_GUIDE_FILTERED: 'unified.institution_guide.filtered',
  UNIFIED_INSTITUTION_GUIDE_INSTITUTION_CLICKED: 'unified.institution_guide.institution_clicked',
  UNIFIED_INSTITUTION_GUIDE_PAGED: 'unified.institution_guide.paged',
  UNIFIED_PUBLIC_PAGE_VIEWED: 'unified.public.page_viewed',
  UNIFIED_VIDEO_PLAYED: 'unified.video.played',
  UNIFIED_PUBLIC_CONTENT_CLICKED: 'unified.public.content_clicked',
  UNIFIED_PUBLIC_CTA_CLICKED: 'unified.public.cta_clicked',
  UNIFIED_PUBLIC_GHOST_STUDENT_CREATED: 'unified.public.ghost_student_created',
  UNIFIED_PUBLIC_REGION_SWITCHED: 'unified.public.region_switched',
  UNIFIED_PUBLIC_REGION_DISMISSED: 'unified.public.region_dismissed',
  UNIFIED_PUBLIC_REGION_SELECTOR_SHOWN: 'unified.public.region_selector_shown',
  UNIFIED_PUBLIC_REGION_SELECTOR_DISMISSED: 'unified.public.region_selector_dismissed',
  UNIFIED_PUBLIC_REGION_PREFERENCE_SET: 'unified.public.region_preference_set',
  UNIFIED_PUBLIC_REGION_PROMPT_SHOWN: 'unified.public.region_prompt_shown',

  UNIFIED_AUTH_LOGIN_STARTED: 'unified.auth.login_started',
  UNIFIED_AUTH_LOGIN_COMPLETED: 'unified.auth.login_completed',
  UNIFIED_AUTH_REGISTRATION_STARTED: 'unified.auth.registration_started',
  UNIFIED_AUTH_SIGNUP_COMPLETED: 'unified.auth.signup_completed',
  UNIFIED_AUTH_AUTO_SIGNUP_COMPLETED: 'unified.auth.auto_signup_completed',
  UNIFIED_AUTH_PASSWORD_SETUP_COMPLETED: 'unified.auth.password_setup_completed',
  UNIFIED_AUTH_GHOST_CONVERTED: 'unified.auth.ghost_converted',
  UNIFIED_AUTH_LOGOUT: 'unified.auth.logout',
  UNIFIED_AUTH_SCHOOL_ACCOUNT_REFUSED: 'unified.auth.school_account_refused',
  UNIFIED_AUTH_SCHOOL_ACCOUNT_SCHOOLS_SITE_CLICKED: 'unified.auth.school_account.schools_site_clicked',
  UNIFIED_AUTH_SCHOOL_ACCOUNT_PERSONAL_EMAIL_CLICKED: 'unified.auth.school_account.personal_email_clicked',

  UNIFIED_CONSIDERATIONS_PROFILE_VIEWED: 'unified.considerations.profile_viewed',
  UNIFIED_CONSIDERATIONS_PROFILE_DISMISSED: 'unified.considerations.profile_dismissed',
  UNIFIED_CONSIDERATIONS_AREA_PROGRESS_VIEWED: 'unified.considerations.area_progress_viewed',
  UNIFIED_CONSIDERATIONS_CLARITY_VIEWED: 'unified.considerations.clarity_viewed',

  UNIFIED_CONTENT_ASSET_STARTED: 'unified.content.asset.started',
  UNIFIED_CONTENT_ASSET_NODE_VIEWED: 'unified.content.asset.node_viewed',
  // One per node, carrying that node's derived scalars plus its raw `events[]` interaction
  // trail. The keys inside `events[]` are not supported in Lexicon, so the array's inner
  // fields never appear in the data dictionary — anything a dashboard needs is a scalar.
  UNIFIED_CONTENT_ASSET_NODE_COMPLETE: 'unified.content.asset.node_complete',
  // One per event an html_embed file reports, filed by the player on the file's behalf: the file
  // runs on the blob host and cannot reach analytics as the student. Its own props carry an
  // `embed_` prefix.
  UNIFIED_CONTENT_HTML_EMBED_EVENT: 'unified.content.html_embed.event',
  UNIFIED_CONTENT_ASSET_COMPLETED: 'unified.content.asset.completed',
  UNIFIED_CONTENT_ASSET_SKILL_AWARDED: 'unified.content.asset.skill_awarded',
  UNIFIED_CONTENT_ASSET_SENTIMENT: 'unified.content.asset.sentiment',
  UNIFIED_CONTENT_ASSET_EXITED: 'unified.content.asset.exited',
  UNIFIED_CONTENT_ASSET_COMPLETION_CTA_CLICKED: 'unified.content.asset.completion_cta_clicked',

  UNIFIED_CONTENT_COLLECTION_STARTED: 'unified.content.collection.started',
  UNIFIED_CONTENT_COLLECTION_ASSET_SELECTED: 'unified.content.collection.asset_selected',
  UNIFIED_CONTENT_COLLECTION_COMPLETED: 'unified.content.collection.completed',
  UNIFIED_CONTENT_SPOTLIGHT_LINK_CLICKED: 'unified.content.spotlight_link_clicked',
  UNIFIED_CONTENT_COLLECTION_DISCLAIMER_OPENED: 'unified.content.collection.disclaimer_opened',
  UNIFIED_CONTENT_FEEDBACK_SURVEY_STARTED: 'unified.content.feedback_survey.started',
  UNIFIED_CONTENT_FEEDBACK_SURVEY_COMPLETED: 'unified.content.feedback_survey.completed',
  UNIFIED_CONTENT_FEEDBACK_SURVEY_SKIPPED: 'unified.content.feedback_survey.skipped',

  UNIFIED_JOB_VIEWED: 'unified.job.viewed',
  UNIFIED_JOB_SENTIMENT: 'unified.job.sentiment',
  UNIFIED_JOB_EXITED: 'unified.job.exited',
  UNIFIED_INSTITUTION_VIEWED: 'unified.institution.viewed',
  UNIFIED_INSTITUTION_SENTIMENT: 'unified.institution.sentiment',
  UNIFIED_INSTITUTION_EXITED: 'unified.institution.exited',
  UNIFIED_INSTITUTION_SOCIAL_POST_CLICKED: 'unified.institution.social_post_clicked',
  UNIFIED_INSTITUTION_WEBSITE_CLICKED: 'unified.institution.website_clicked',
  UNIFIED_INSTITUTION_EVENT_CTA_CLICKED: 'unified.institution.event_cta_clicked',
  UNIFIED_INSTITUTION_EVENT_DETAILS_CLICKED: 'unified.institution.event_details_clicked',
  UNIFIED_INSTITUTION_ALUMNI_LINK_CLICKED: 'unified.institution.alumni_link_clicked',
  UNIFIED_INSTITUTION_AREA_OF_STUDY_TILE_CLICKED: 'unified.institution.area_of_study_tile_clicked',

  UNIFIED_ENTITY_SAVED: 'unified.entity.saved',
  UNIFIED_ENTITY_UNSAVED: 'unified.entity.unsaved',

  UNIFIED_JOB_CANDIDATE_LIST_VIEWED: 'unified.job_candidate.list_viewed',
  UNIFIED_JOB_CANDIDATE_EMPTY_EXPLORE_CLICKED: 'unified.job_candidate.empty_explore_clicked',
  UNIFIED_JOB_CANDIDATE_TOP_SET: 'unified.job_candidate.top_set',
  UNIFIED_JOB_CANDIDATE_SET_ASIDE: 'unified.job_candidate.set_aside',
  UNIFIED_JOB_CANDIDATE_RESTORED: 'unified.job_candidate.restored',
  UNIFIED_JOB_CANDIDATE_GLANCE_VIEWED: 'unified.job_candidate.glance_viewed',
  UNIFIED_JOB_CANDIDATE_COMPARE_VIEWED: 'unified.job_candidate.compare_viewed',
  UNIFIED_JOB_CANDIDATE_ROUTE_DEEP_DIVE_VIEWED: 'unified.job_candidate.route_deep_dive_viewed',
  UNIFIED_JOB_CANDIDATE_ROUTE_SHORTLISTED: 'unified.job_candidate.route_shortlisted',
  UNIFIED_JOB_CANDIDATE_ROUTE_SET_ASIDE: 'unified.job_candidate.route_set_aside',
  UNIFIED_JOB_CANDIDATE_ROUTE_REMOVED: 'unified.job_candidate.route_removed',
  UNIFIED_JOB_PROS_CONS_OPENED: 'unified.job.pros_cons_opened',
  UNIFIED_JOB_CANDIDATE_CARD_ROUTE_CLICKED: 'unified.job_candidate.card_route_clicked',
  UNIFIED_JOB_CANDIDATE_WEIGH_UP_VIEWED: 'unified.job_candidate.weigh_up_viewed',

  UNIFIED_REWARDS_STORE_VIEWED: 'unified.rewards.store_viewed',
  UNIFIED_REWARDS_PRIZE_STEPS_VIEWED: 'unified.rewards.prize_steps_viewed',
  UNIFIED_REWARDS_COINS_EARNED: 'unified.rewards.coins_earned',
  UNIFIED_WALLET_ITEM_VIEWED: 'unified.wallet.item_viewed',
  UNIFIED_FIRST_BADGE_CELEBRATION_VIEWED: 'unified.first_badge_celebration.viewed',
  UNIFIED_FIRST_BADGE_CELEBRATION_DISMISSED: 'unified.first_badge_celebration.dismissed',
  UNIFIED_FIRST_BADGE_CELEBRATION_EXPLORE_CLICKED: 'unified.first_badge_celebration.explore_clicked',

  // Ambient surfaces (wallet/saved/account/rewards/library/portfolio) opening as activities. Fired once per open.
  UNIFIED_WALLET_VIEWED: 'unified.wallet.viewed',
  UNIFIED_SAVED_VIEWED: 'unified.saved.viewed',
  UNIFIED_ACCOUNT_VIEWED: 'unified.account.viewed',
  UNIFIED_ACCOUNT_PASSWORD_SAVED: 'unified.account.password_saved',
  UNIFIED_REWARDS_VIEWED: 'unified.rewards.viewed',
  UNIFIED_LIBRARY_VIEWED: 'unified.library.viewed',
  UNIFIED_PORTFOLIO_VIEWED: 'unified.portfolio.viewed',
  UNIFIED_PORTFOLIO_SAVED: 'unified.portfolio.saved',

  UNIFIED_WESTPAC_CASHOUT_BLOCKED_VIEWED: 'unified.westpac.cashout.blocked_viewed',
  UNIFIED_WESTPAC_CASHOUT_CONFIRMED: 'unified.westpac.cashout.confirmed',

  UNIFIED_BANK_TRANSFER_CASHOUT_BLOCKED_VIEWED: 'unified.bank_transfer.cashout.blocked_viewed',

  UNIFIED_CASHOUT_BLOCKED_VIEWED: 'unified.cashout.blocked_viewed',
  UNIFIED_CASHOUT_SERVICE_SELECTED: 'unified.cashout.service_selected',

  UNIFIED_CONTENT_GTKY_SECTION_STARTED: 'unified.content.gtky.section_started',
  UNIFIED_CONTENT_GTKY_QUESTION_VIEWED: 'unified.content.gtky.question_viewed',
  UNIFIED_CONTENT_GTKY_QUESTION_ANSWERED: 'unified.content.gtky.question_answered',
  UNIFIED_CONTENT_GTKY_SECTION_COMPLETED: 'unified.content.gtky.section_completed',

  UNIFIED_STORY_COMPLETED: 'unified.content.story.completed',

  UNIFIED_AVATAR_SELECTED: 'unified.avatar.selected',
} as const;

/** Every analytics event name the app is allowed to file. */
export type EventName = (typeof EVENTS)[keyof typeof EVENTS];
